'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IBONUS_PAYMENT_SLUG = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _Slider = require('components/Slider');

var _components2 = require('components');

var _AmountFormat = require('components/AmountFormat');

var _AmountFormat2 = _interopRequireDefault(_AmountFormat);

var _payment = require('redux/actions/payment');

var _voice_code = require('redux/actions/voice_code');

var _modal = require('redux/actions/modal');

var _utils = require('helpers/utils');

require('./style.less');

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    IBonusPayment: {
        displayName: 'IBonusPayment'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/IBonusPayment/index.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var IBONUS_PAYMENT_SLUG = exports.IBONUS_PAYMENT_SLUG = 'i_bonus';

var IBonusPayment = _wrapComponent('IBonusPayment')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        user: state.auth.user,
        isPayOrder: state.payment.isPayOrder,
        preload: state.payment.preload,
        errorPay: state.payment.errorPay,
        errorCode: state.payment.errorCode,
        shopId: state.setting.shopId,
        sum: state.personal_order_detail.order.sum,
        lang: state.lang
    };
}, { paymentIbonus: _payment.paymentIbonus, resetPaymentIbonus: _payment.resetPaymentIbonus, resetVoiceCode: _voice_code.resetVoiceCode, checkCodeSendForPaymentIbonus: _payment.checkCodeSendForPaymentIbonus, modalHide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(IBonusPayment, _Component);
    (0, _createClass3.default)(IBonusPayment, null, [{
        key: 'checkSlug',
        value: function checkSlug(name) {
            return name === IBONUS_PAYMENT_SLUG;
        }
    }]);

    function IBonusPayment(props, context) {
        (0, _classCallCheck3.default)(this, IBonusPayment);

        var _this = (0, _possibleConstructorReturn3.default)(this, (IBonusPayment.__proto__ || (0, _getPrototypeOf2.default)(IBonusPayment)).call(this, props, context));

        _this._elements = {};

        _this.onSubmit = function (event) {
            var alert = {};
            alert.message = _this.props.lang['store.ibonus_payment.not_enough_funds'];
            event.preventDefault();
            // TODO LANG проверить, как работает условие при установке языка, отличного от русского
            if (_this.props.error == "Введите пожалуйста ранее высланный вам код") {
                _this.props.setStepConfirm(true);
                _this.setState({ stepConfirmIn: true });
            }
            if (_this.state.checkedPaymentAmount === 0 || _this.state.checkedPaymentAmount < Number(_this.props.sum)) {
                _this.showOuterAlert(alert);
            } else {
                _this.props.checkCodeSendForPaymentIbonus(function (isSendCode) {
                    if (isSendCode) {
                        _this.props.setStepConfirm(true);
                        _this.setState({ stepConfirmIn: true, outerAlert: null });
                    } else {
                        _this.props.paymentIbonus(_this.state.checkedPaymentId, _this.props.operationId);
                    }
                }, _this.props.shopId, _this.props.orderId);
            }
        };

        _this.onSubmitConfirm = function (event) {
            event.preventDefault();
            _this.props.paymentIbonus(_this.state.checkedPaymentId, _this.props.operationId, _this.state.code);
            _this.props.resetVoiceCode();
        };

        _this.onSlide = function (_ref) {
            var index = _ref.index,
                lastIndex = _ref.lastIndex,
                element = _ref.element;

            if (_this._elements.hasOwnProperty(index)) {
                _this.setState({
                    checkedPaymentId: parseInt(_this._elements[index].id, 10) || 0,
                    checkedPaymentAmount: parseInt(_this.props.user.amount[index].amount, 10) || 0,
                    selectSlide: index
                });
                if (_this.props.errorPay) {
                    _this.props.resetPaymentIbonus();
                }
            }
        };

        _this.showAlert = function (alert) {
            if (_this.props.errorPay) {
                if (_this.props.errorCode === null || _this.props.errorCode === undefined) {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        _this.props.lang['store.common.server_is_unavailable']
                    );
                } else {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        _this.props.errorPay
                    );
                }
            } else if (_this.props.alert || alert) {
                var _ref2 = _this.props.alert || alert,
                    message = _ref2.message,
                    style = _ref2.style;

                return _react3.default.createElement(
                    _reactBootstrap.Alert,
                    { bsStyle: style || 'danger', className: 'inner-right-xs' },
                    message
                );
            }

            return '';
        };

        _this.showOuterAlert = function (alert) {
            _this.setState({ outerAlert: alert });
        };

        _this.renderPayments = function () {
            var user = _this.props.user || {};
            var _user$amount = user.amount,
                amount = _user$amount === undefined ? [] : _user$amount;

            var elements = amount.map(function (amount, index) {
                return _react3.default.createElement(_AmountFormat2.default, { key: index, amount: amount, wrapProps: {
                        className: "one_slider",
                        ref: function ref(element) {
                            _this._elements[index] = {
                                id: amount.id
                            };
                        }
                    } });
            });

            return _react3.default.createElement(
                _Slider.Slider,
                {
                    loop: false,
                    selected: _this.state.selectSlide,
                    showArrows: true,
                    showNav: true,
                    onSlide: _this.onSlide
                },
                elements
            );
        };

        _this.renderAccountForm = function () {
            return _react3.default.createElement(
                'form',
                { onSubmit: _this.onSubmit },
                _this.state.outerAlert ? _this.showAlert(_this.state.outerAlert) : _this.showAlert(),
                _react3.default.createElement(
                    'div',
                    { className: 'amount-wrap' },
                    _react3.default.createElement(
                        'p',
                        { className: 'amount-title' },
                        _this.props.lang['store.ibonus_payment.select_account'],
                        ':'
                    ),
                    _this.renderPayments()
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 submit' },
                        _react3.default.createElement('input', { type: 'submit', value: '\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C', className: 'le-button big' })
                    )
                )
            );
        };

        _this.renderConfirmCodeForm = function () {
            var lang = _this.props.lang;


            return _react3.default.createElement(
                'form',
                { onSubmit: _this.onSubmitConfirm, className: 'confirm-send-code-payment-pipo' },
                _this.state.outerAlert ? _this.showAlert(_this.state.outerAlert) : _this.showAlert(),
                _react3.default.createElement(
                    'div',
                    { className: 'form-group confirm-send-code-payment-pipo__wrap' },
                    _react3.default.createElement(
                        'label',
                        { htmlFor: 'confirmCode', className: 'control-label' },
                        lang['store.ibonus_payment.confirmation_code'],
                        ':'
                    ),
                    _react3.default.createElement('input', {
                        name: 'code',
                        onChange: function onChange(e) {
                            if ((0, _utils.validateNumeric)(e.target.value)) {
                                _this.setState({ code: e.target.value });
                            }
                        },
                        placeholder: lang['store.ibonus_payment.confirmation_code'],
                        type: (0, _utils.isMobileDevice)() ? "number" : "text",
                        pattern: '\\d*',
                        id: 'confirmCode',
                        className: 'form-control'
                    })
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 submit' },
                        _react3.default.createElement('input', { type: 'submit', value: lang['store.common.confirm'], className: 'le-button big' })
                    )
                ),
                _react3.default.createElement(_components2.VoiceCode, {
                    login: _this.props.user.phone,
                    source: 'confirm_payout',
                    showAlert: _this.showOuterAlert,
                    whiteList: true
                })
            );
        };

        _this.state = {
            selectSlide: 0,
            checkedPaymentId: parseInt(_this.props.user.amount[0].id, 10) || 0,
            checkedPaymentAmount: parseInt(_this.props.user.amount[0].amount, 10) || 0,
            code: '',
            outerAlert: null,
            stepConfirmLocal: _this.props.stepConfirm,
            stepConfirmIn: false
        };

        return _this;
    }

    (0, _createClass3.default)(IBonusPayment, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props = this.props,
                stepConfirm = _props.stepConfirm,
                errorPay = _props.errorPay,
                lang = _props.lang;

            // TODO LANG проверить, как работает условие при установке языка, отличного от русского

            if (nextProps.errorPay == "Введите пожалуйста ранее высланный вам код") {
                this.setState({
                    stepConfirmLocal: true
                });
            }

            if (stepConfirm !== nextProps.stepConfirm) {
                this.setState({
                    stepConfirmLocal: nextProps.stepConfirm
                });
            }

            if (!nextProps.user) {
                this.props.modalHide();
                return;
            }

            if (this.props.isPayOrder === false && nextProps.isPayOrder === true) {
                this.props.resetPaymentIbonus();
                if (this.props.callbackPay) {
                    this.props.callbackPay();
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetPaymentIbonus();
        }
    }, {
        key: 'render',
        value: function render() {

            var content = void 0;

            if (this.state.stepConfirmLocal || this.state.stepConfirmIn) {
                content = this.renderConfirmCodeForm();
            } else {
                content = this.renderAccountForm();
            }

            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload },
                _react3.default.createElement(
                    'div',
                    { className: 'i-bonus-payment-form', id: 'auth-form' },
                    _react3.default.createElement(
                        'div',
                        { className: 'bordered' },
                        content
                    )
                )
            );
        }
    }]);
    return IBonusPayment;
}(_react2.Component), _class2.propTypes = {
    user: _react2.PropTypes.object,
    operationId: _react2.PropTypes.number.isRequired,
    orderId: _react2.PropTypes.number.isRequired,
    isPayOrder: _react2.PropTypes.bool,
    preload: _react2.PropTypes.bool,
    callbackPay: _react2.PropTypes.func,
    errorPay: _react2.PropTypes.string,
    modalHide: _react2.PropTypes.func.isRequired,
    lang: _react2.PropTypes.object
}, _class2.defaultProps = {
    // user: {},
    modalHide: function modalHide() {},
    orderId: 0,
    operationId: 0
}, _temp)) || _class));

exports.default = IBonusPayment;


//////////////////
// WEBPACK FOOTER
// ./src/components/IBonusPayment/index.jsx
// module id = 1680
// module chunks = 0